import {
  LEAD_DETAIL_CHANGE_VALUE,
} from '@/store/constants/mutationTypes';

const mutations = {
  [LEAD_DETAIL_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state[field] = value;
  },
  LEAD_DETAIL_SET: (state, payload) => {
    const {
      lead,
      cycles,
      customer,
      hvac,
      alert,
      pastAlerts,
      activeAlertList,
      address,
      loading,
    } = payload;

    state.lead = lead;
    state.activeAlertList = activeAlertList;
    state.cycles = cycles;
    state.customer = customer;
    state.hvac = hvac;
    state.alert = alert;
    state.pastAlerts = pastAlerts;
    state.address = address;
    state.loading = loading;
  },
};

export default mutations;
